'use strict'

import * as types from '@/store/types.js'

const state = {
  statusRequest: null,
  receiptInfo: null
}

const mutations = {
  [types.APP.statusRequest.set]: (store, {statusRequest}) => {
    store.statusRequest = statusRequest
  },
  [types.APP.receiptInfo.set]: (store, {receiptInfo}) => {
    store.receiptInfo = receiptInfo
  }
}

const actions = {
  [types.APP.statusRequest.set](context, data) {
    context.commit(types.APP.statusRequest.set, data)
  },
  [types.APP.receiptInfo.set](context, data) {
    context.commit(types.APP.receiptInfo.set, data)
  }
}

export default {
  state,
  mutations,
  actions
}
